import logger from "@/utils/logger.js";
import axios from "axios";
import {DocumentModel} from "@/models/DocumentModel.js";
import { checkToken } from '@/utils/lambdaUtils';
import { useAuthStore } from '@/stores/authStore';
import api from "@/services/api.js";

const baseUrl = import.meta.env.VITE_APP_API_BASE_URL + '/document/';

export const getDocuments = async () => {
    try {
        const store = useAuthStore();
        await checkToken();
        const response = await axios.get(`${baseUrl}get_all_documents`, {
            headers: {
                'Authorization': `Bearer ${store.token}`,
            }
        });
        if (Array.isArray(response.data)) {
            return response.data.map(item => new DocumentModel(item));
        } else {
            throw new Error('Invalid response data format');
        }
    } catch (error) {
        logger.error('Error getting documents ', error);
    }
};

export const saveDocument = async (document) => {
    if (!document) {
        throw new Error('Missing required document body object');
    }

    try {
        const store = useAuthStore();
        await checkToken();
        const response = await api.post(`${baseUrl}save_document`,document, {
            headers: {
                'Authorization': `Bearer ${store.token}`,
            }
        });
        if(response.data==="success"){
            return response.data;
        }else {
            logger.error('Error saving document ', response.data);
            throw new Error('Error in backend saving document :: '+ response.data);
        }
    } catch (error) {
        logger.error('Error saving document ', error);
        throw error;
    }
};

export const saveEditDocument = async (editDocument) => {
    if (!editDocument) {
        throw new Error('Missing required editDocument body object');
    }

    try {
        const store = useAuthStore();
        await checkToken();

        delete editDocument.updatedAt;
        delete editDocument.createdAt;

        const response = await api.post(`${baseUrl}save_edit_document`,editDocument, {
            headers: {
                'Authorization': `Bearer ${store.token}`,
            }
        });
        if(response.data==="success"){
            return response.data;
        }else {
            logger.error('Error saving edit document ', response.data);
            throw new Error('Error in backend saving edit document :: '+ response.data);
        }
    } catch (error) {
        logger.error('Error saving edit document ', error);
        throw error;
    }
};
